import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@emotion/react";
import drawerDim from "../../../theme/drawerDimensions";
import { Box, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import { t } from "i18next";
import {
  privacyPolicyRoute,
  termsOfServiceRoute,
} from "../../../routes/reactRoutes";

function BottomBar(props) {
  const theme = useTheme();
  const linkSx = {
    color: theme.palette.primary.main,
    fontWeight: 500,
    letterSpacing: "0.5px",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      component="footer"
      sx={{
        width: { md: `calc(100% - ${drawerDim.width}px)` },
        ml: { md: `${drawerDim.width}px` },
        bottom: 0,
        top: "auto",
        height: `${drawerDim.bottom}px`,
        letterSpacing: "2px",
        display: "flex",
        alignItems: "center",
        flexDirection: theme.direction === "rtl" ? "row-reverse" : "row",
        justifyContent: "center",
        px: 5,
        color: theme.palette.text.main,
        background: theme.palette.whiteblack.main,
        fontWeight: 300,
        fontSize: "0.875rem",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", pointerEvents: "auto" }}>
          <Box sx={{ p: 1, color: theme.palette.primary.main }}>&#169;</Box>{" "}
          {t("copyright")}
        </Box>
      </Box>
      <Box
        sx={{
          ml: "auto",
          display: "flex",
          alignItems: "center",
          gap: 2,
          letterSpacing: "0.5px",
          zIndex: 1,
        }}
      >
        <MuiLink
          component={Link}
          to={termsOfServiceRoute}
          target="_blank"
          rel="noopener noreferrer"
          sx={linkSx}
        >
          Terms of Service
        </MuiLink>
        <Box sx={{ color: theme.palette.divider }}>|</Box>
        <MuiLink
          component={Link}
          to={privacyPolicyRoute}
          target="_blank"
          rel="noopener noreferrer"
          sx={linkSx}
        >
          Privacy Policy
        </MuiLink>
      </Box>
    </AppBar>
  );
}

export default BottomBar;
